import {
    SHOW_SPINNER,
    HIDE_SPINNER

} from '../action/SpinnerActions'

const initialState = {
    show : false,
    text : ''
  }

  export default function SpinnerReducer(
      state = initialState,
      action
  ){
    switch (action.type){
        case SHOW_SPINNER :
            return {
                ...state,
                show : true,
                text : action.payload.text
            }
        case HIDE_SPINNER :
            return {
                ...state,
                show : false
            }
            
        default: 
        return state
    }
  }